import { SellerDirectoryBanner } from './SellerDirectoryBanner';
import { SellerDirectoryBannerTest } from './SellerDirectoryBannerTest';
import {
  useSuspenseGetApplication,
  useSuspenseGetBuyerSellerDirectory,
  useSuspenseGetStateByStateKey,
} from '../../../../api/lending/lapiHooks.suspense';

export const SellerDirectoryBannersSkeleton = () => (
  <div className="mb-xl grid w-full grid-cols-1 gap-xl">
    <div className="h-[70px] w-full animate-pulse rounded-s bg-structure-95" />
  </div>
);

export const SellerDirectoryBanners = () => {
  const { application } = useSuspenseGetApplication();
  const { state } = useSuspenseGetStateByStateKey();
  const { sellers } = useSuspenseGetBuyerSellerDirectory();

  if (application?.status === 'declined') return null;

  const isSoleTrader = state?.application?.company?.type === 'sole_trader';

  if (isSoleTrader) return <SellerDirectoryBannerTest />;
  if (isSoleTrader === false && sellers) return <SellerDirectoryBanner />;

  return null;
};
